import React from "react";
import ServerSideService from "../../utilities/serverSideService";
import WbmLogo, { IWbmLogoProps } from "./wbmLogo";

const WbmLogoWrapper = (props: IWbmLogoProps) => {
  return (
    <>
      {ServerSideService.isServerSide ? (
        <WbmLogo {...props} />
      ) : (
        <WbmLogo {...props} />
      )}
    </>
  );
};

export default WbmLogoWrapper;
